import React, { useCallback } from 'react';
import { useModalStore } from '@/store';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import useRequireAuth from '@/hooks/useRequireAuth';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';

// Ghost users are deprecated; route anon visitors through the unified
// AuthCTA modal instead of the legacy `GhostSignupModal`.
const MemoryRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  const { openModal } = useModalStore(state => state.actions);
  const requireAuth = useRequireAuth();

  const handleCreateMemoryClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    requireAuth(
      () => openModal('CreateMemoryModal'),
      {
        source: 'memory_header_create',
        title: 'Sign in to save Memories',
        subtitle: 'Memories travel with your account so Gab remembers preferences across every chat.',
        icon: 'brain',
      },
    );
  }, [openModal, requireAuth]);

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="plus"
        tooltip="New memory"
        label={isXS ? undefined : "New memory"}
        onPress={handleCreateMemoryClick}
      />
    </NavigationBarButtonContainer>
  );
});

MemoryRouteNavigationHeaderRight.displayName = 'MemoryRouteNavigationHeaderRight';

const MemoryRouteNavigationOptions = {
  title: 'Memory',
  headerTitle: 'Memory',
  headerBackVisible: false,
  headerRight: () => <MemoryRouteNavigationHeaderRight />,
};

export default MemoryRouteNavigationOptions;

